import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-cookies',
  imports: [RouterLink],
  templateUrl: './cookies.html',
  styleUrl: '../legal-pages.scss',
})
export class Cookies {}
